<template>
  <v-container class="news-section-wrapper" fluid>
    <v-row>
      <v-col class="col-12 col-md-10 pa-md-0" offset-md="1">
        <h2 v-html="data.title"></h2>
        <VueSlickCarousel v-if="isDesktop" v-bind="settings">
          <template v-for="(post, i) in data.newsList">
            <div :key="i" class="content">
              <v-img
                contain
                :src="require('@/assets/images/homepage/' + post.image)"
              />
              <div class="texts-wrapper">
                <div class="tags-list">
                  <span
                    v-for="(tag, t) in post.tagsList"
                    :key="t"
                    v-html="tag.name"
                  ></span>
                </div>
                <h3 v-html="post.title"></h3>
                <p v-html="post.excerpt"></p>
              </div>
              <a
                class="button"
                :href="post.button.url"
                :target="post.button.external_url === true ? '_blank' : '_self'"
                >{{ post.button.text }}</a
              >
            </div>
          </template>
        </VueSlickCarousel>
        <v-container v-else fluid class="news-list-wrapper">
          <ul class="row">
            <li
              v-for="(post, i) in data.newsList"
              :key="i"
              class="col col-12 pa-0"
            >
              <div class="content">
                <v-img
                  contain
                  :src="require('@/assets/images/homepage/' + post.image)"
                />
                <div class="texts-wrapper">
                  <div class="tags-list">
                    <span
                      v-for="(tag, t) in post.tagsList"
                      :key="t"
                      v-html="tag.name"
                    ></span>
                  </div>
                  <h3 v-html="post.title"></h3>
                  <p v-html="post.excerpt"></p>
                </div>
                <a
                  class="button"
                  :href="post.button.url"
                  :target="
                    post.button.external_url === true ? '_blank' : '_self'
                  "
                  >{{ post.button.text }}</a
                >
              </div>
            </li>
          </ul>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
  name: 'NewsSection',
  components: {
    VueSlickCarousel,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      settings: {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: true,
        arrows: false,
        autoplay: false,
      },
    };
  },
  computed: {
    isDesktop() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.news-section-wrapper
  padding-top: 100px
  padding-bottom: 100px
  h2
    display: inline-block
    font-family: 'metropolissemi_bold'
    font-weight: 600
    font-size: 32px
    line-height: 1.8
    color: #003036
    border-bottom: 4px solid #26D07C
    text-shadow: 0.5px 0.5px #003036
    margin-bottom: 70px
  ::v-deep
    .slick-slide
      position: relative
      transition: all 300ms ease-in-out
      .content
        position: relative
        margin-right: 0 !important
        .v-image
          max-width: calc(100% - 15px)
    .slick-dots
      padding: 0 !important
      bottom: inherit
      top: -105px
      right: 0
      text-align: right
      li
        width: 23px
        height: 23px
        margin: 0 10px
        transition: all 300ms ease-in-out
        &.slick-active
          transition: all 300ms ease-in-out
          button
            width: 23px
            height: 23px
            &:before
              background: #ffffff
              border: 6px solid #26D07C
              width: 23px
              height: 23px
              color: transparent
              border-radius: 50px
              line-height: 1
              top: 0
              left: 0
              transition: all 300ms ease-in-out
        button
          width: 23px
          height: 23px
          padding: 0
          &:before
            background: #003036
            width: 16px
            height: 16px
            color: transparent
            border-radius: 50px
            line-height: 1
            opacity: 1
            top: 3px
            left: 3px
            transition: all 300ms ease-in-out
  .news-list-wrapper ul li,
  .slick-slide
    &:hover
      .content
        &:before
          opacity: 1
          transition: all 300ms ease-in-out
        .texts-wrapper
          transition: all 150ms ease-in-out
          cursor: default
          opacity: 0
        .button
          transition: all 150ms ease-in-out
          opacity: 1
    .content
      margin-right: 15px
      &:before
        background: linear-gradient(0deg, rgba(0, 48, 54, 0.0001) 0%, #003036 100%)
        content: ""
        position: absolute
        display: block
        width: calc(100% - 15px)
        height: 100%
        top: 0
        left: 0
        border-radius : 16px
        opacity: 0
        z-index: 1
        transition: all 300ms ease-in-out
      &:after
        background: linear-gradient(180deg, rgba(0, 48, 54, 0.0001) 0%, #003036 100%)
        content: ""
        position: absolute
        display: block
        width: calc(100% - 15px)
        height: 100%
        top: 0
        left: 0
        border-radius : 16px
        z-index: 1
      .v-image
        border-radius : 16px
      .texts-wrapper
        position: absolute
        display: block
        max-width: calc(100% - 30px)
        left: 8px
        bottom: 44px
        z-index: 2
        opacity: 1
        transition: all 150ms ease-in-out
        @media screen and (min-width: 1280px)
          max-width: calc(100% - 45px)
          left: 15px
        @media screen and (min-width: 1920px)
          max-width: calc(100% - 96px)
          left: 48px
        .tags-list
          display: flex
          gap: 15px
          flex-wrap: wrap
          margin-bottom: 25px
          span
            background: #ffffff
            font-family: 'metropolisbold'
            font-style: normal
            font-weight: 700
            font-size: 14px
            line-height: 1
            color: #26D07C
            text-align: left
            text-transform: uppercase
            word-break: break-word
            padding: 8px 16px
            border-radius: 100px
        h3
          font-family: 'metropolisbold'
          font-style: normal
          font-weight: 700
          font-size: 20px
          line-height: 1
          color: #FFFFFF
          margin-bottom: 5px
        p
          display: block
          min-height: 60px
          font-family: 'metropolisregular'
          font-style: normal
          font-weight: 400
          font-size: 20px
          line-height: 1.4
          color: #FFFFFF
          ::v-deep
            span
              font-family: 'metropolisbold'
              font-weight: 700
      .button
        background: #3DCF8E
        position: absolute
        display: inline-block
        width: 270px
        font-family: 'metropolisbold'
        font-style: normal
        font-weight: 700
        font-size: 16px
        line-height: 1
        text-transform: uppercase
        color: #FFFFFF
        align-items: center
        padding: 12px 48px
        border-radius: 20px
        outline: none
        text-decoration: none
        left: 50%
        bottom: 34%
        transform: translate(-50%, 0)
        z-index: 2
        opacity: 0
        transition: all 150ms ease-in-out
  @media screen and (max-width: 959px)
    padding-top: 70px
    padding-bottom: 70px
    .row
      .col.offset-md-1
        display: flex
        flex-flow: column
        align-items: center
    .news-list-wrapper
      padding: 0 2px
      ul
        padding: 0
        margin: 0
        list-style-type: none
        li
          position: relative
          display: block
          margin-bottom: 25px
          transition: all 300ms ease-in-out
          .content
            margin: 0
            &:before,
            &:after
              width: 100%
            .texts-wrapper
              h3,
              p
                font-size: 16px
</style>
